module.exports = __webpack_public_path__ + "static/media/trieste-27.ce644fc8.jpg";